<script lang="ts">
  import { Button, ShoppingCartSolid } from "@getprovi/craft";
  import CartStore from "@retailer/svelte/stores/CartStore";

  $: totalItems = ($CartStore?.total_items ? $CartStore.total_items : 0).toString() as string;
</script>

<Button
  class="craft area-cart"
  data-cart-items={totalItems}
  data-grid-area="cart"
  href="/cart"
  iconBefore={ShoppingCartSolid}
  label={totalItems}
  size="lg"
  id="cart-button"
  testId="cart-button"
/>
